import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import BasicTabs from "./components/tabs";
import styles from "./style.module.css";
import { useTheme } from "../../../../context/themeContext";
import useManageProjects from "../../../../hooks/useManageProjects";
import { useSelector } from "react-redux";

function Projects() {
  const { theme } = useTheme();
  const publicUser = useSelector((state) => state.publicUser.value);
  const { fetchHostedProjects, fetchLikedProjects } = useManageProjects();

  useEffect(() => {
    fetchHostedProjects(publicUser);
    fetchLikedProjects(publicUser);
  }, [publicUser]);

  return (
    <Box className={styles.projects}>
      <Typography
        variant="body1"
        sx={{
          fontSize: "1.5rem",
          fontWeight: "500",
          textAlign: "centerd",
          display: "flex",
          alignSelf: "stretch",
          alignItems: "center",
          justifyContent: "center",
          color: theme.palette.darkgrey.darkgrey600,
        }}
      >
        Projects
      </Typography>
      <BasicTabs />
    </Box>
  );
}

export default Projects;
